module.exports = __webpack_public_path__ + "img/R6__0481.1e2ed7d3.jpg";